const mockData = {
  searchEntityDtos: [
    {
      lastRun: '2020-12-10 16:49:08.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'SUCCESS',
      lastErrorMessage: null,
      searchEngine: 'HEALTHGRADES',
      sources: [
        {
          baseUrl: null,
          link:
            'https://www.healthgrades.com/physician/dr-neil-ohora-ydrgy?referrerSource=autosuggest',
        },
      ],
    },
    {
      lastRun: '2020-12-10 19:03:32.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'ERROR',
      lastErrorMessage: 'No result found',
      searchEngine: 'RATEMDS',
      sources: [],
    },
    {
      lastRun: '2020-12-10 19:17:23.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'ERROR',
      lastErrorMessage: 'No result found',
      searchEngine: 'ZOCDOC',
      sources: [],
    },
    {
      lastRun: '2020-12-10 19:37:53.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'ERROR',
      lastErrorMessage: {
        message: 'Monthly API calls limit reached: 1000',
      },
      searchEngine: 'VITALS',
      sources: [],
    },
    {
      lastRun: '2020-12-10 19:37:53.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'ERROR',
      lastErrorMessage: {
        message: 'Monthly API calls limit reached: 1000',
      },
      searchEngine: 'WEBMD',
      sources: [],
    },
    {
      lastRun: '2020-12-10 19:30:53.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'ERROR',
      lastErrorMessage: {
        message: 'Monthly API calls limit reached: 1000',
      },
      searchEngine: 'NPIDB',
      sources: [],
    },
    {
      lastRun: '2020-12-10 16:44:34.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'SUCCESS',
      lastErrorMessage: null,
      searchEngine: 'CAREDASH',
      sources: [
        {
          baseUrl: null,
          link: 'https://www.caredash.com/doctors/neil-ohora-dpm-olney-md',
        },
      ],
    },
    {
      lastRun: '2020-12-10 16:44:34.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'SUCCESS',
      lastErrorMessage: null,
      searchEngine: 'TOPNPI',
      sources: [
        {
          baseUrl: null,
          link: 'https://www.topnpi.com/md1669477253/dr-neil-ohora',
        },
      ],
    },
    {
      lastRun: '2020-12-11 03:06:49.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'SUCCESS',
      lastErrorMessage: null,
      searchEngine: 'WELLNESS',
      sources: [
        {
          baseUrl: null,
          link:
            'https://www.wellness.com/dir/1914325/podiatrist/md/olney/neil-ohora-dpm',
        },
      ],
    },
    {
      lastRun: '2020-12-10 17:42:32.000',
      code: '1669477253',
      searchTerm: 'Neil Roy Ohora, MD',
      status: 'SUCCESS',
      lastErrorMessage: null,
      searchEngine: 'YELLOWBOT',
      sources: [
        {
          baseUrl: null,
          link:
            'https://www.yellowbot.com/neil-ohora-dpm-linthicum-heights-md.html',
        },
      ],
    },
  ],
  totalPages: 1,
  totalElements: 2,
  number: 1,
};

export default mockData;
